import { render, staticRenderFns } from "./IntegralRule.vue?vue&type=template&id=4eca082a&"
import script from "./IntegralRule.vue?vue&type=script&lang=js&"
export * from "./IntegralRule.vue?vue&type=script&lang=js&"
import style0 from "./IntegralRule.vue?vue&type=style&index=0&id=4eca082a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports